import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { Link } from "react-router-dom";

import MobileStoreButton from "react-mobile-store-button";
import ContainsArea from "../../Components/ContainsArea/ContainsArea";

import bgimg from "../../assets/images/IZB/IZB Website Skin/IZB Save Plus Account/image_6.png";
import rewardsBanner from "../../assets/images/resources/Group 5.png";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect } from "react";
import VideoSlider from "../../Components/VideoSlider/VideoSlider";


const MobileBanking = () => {
  const bannerPhones = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Group 1000003036.png";
  const bannerPhones1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Banking-New.png";

  // New benefit icons
  const remittancesIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/exchange_4738556%201%20(Colorized).png";
  const qrPaymentsIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/qr-code-scan_4750308%201%20(Colorized).png";
  const termDepositsIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/save-money_11062853%201%20(Colorized).png";
  const walletTransfersIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/wire-transfer_18987599%201%20(Colorized).png";
  const cardlessWithdrawalsIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/withdraw-money_18583760%201%20(Colorized).png";
  const biometricIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/biometric_17782810%201%20(Colorized).png";
  const cardManagementIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/credit-card_10687526%201%20(Colorized).png";
  const billPaymentsIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/invoice_9256718%201%20(Colorized).png";
  const schoolPaymentsIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/scholarship_5741562%201%20(Colorized).png";

  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-mobile-banking-banner.png";

  const img = "https://izbassetsmain.blob.core.windows.net/izbwebassets/mobile-banking-single-page.png";

  const Logo = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Group 402.png";
  const Logo1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Group 403.png";
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const textColor = {
    color: "#9E1B1E",
  };
  const iosUrl =
    "https://apps.apple.com/in/app/izb-mobile-banking/id6754076496";
  const androidUrl =
    "https://play.google.com/store/apps/details?id=com.izb.mobile";
  const content =
    "Indo NXT Mobile Banking  gives you access to your account on your mobile/tab device. Perform your banking tasks from the palm of your hand, from anywhere and at anytime!";
  return (
    <>
      <Breadcrumb Heading="Indo NXT Mobile Banking" img={BackgroundBrundcrumb} />
      <section className="overview-area">
        <div className="container">
          <div className="row">
            <div className="col-md-5 col-xl-5">
              <div className="overview-content-box-one">
                <img src={img} width="100%" alt="" />
              </div>
            </div>
            <div className="col-xl-6 col-md-6 ">
              <div className="overview-content-box-two h-100 d-flex flex-column justify-content-center">
                <div className="inner-title">
                  <h5>Know About</h5>
                  <h2>Indo NXT Mobile Banking </h2>
                </div>
                <div className="text">
                  <p>{content}</p>
                </div>
                <div className=" align-items-center">
                  <Link to={androidUrl} target="_blank" >
                    <img src={Logo} width={150} style={{ textDecoration: "none", border: "none" }} />
                  </Link>
                  <Link to={iosUrl} target="_blank">
                    <img src={Logo1} width={150} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ContainsArea />

      <section
        id="benefits"
        class="benefits-style2-area"
        className="choose-style1-area"
      >
        <div className="container pt-4">
          <div className="text-center my-5">
            <h1 style={{ color: "#484848" }}>Indo NXT Mobile Banking Benefits</h1>
            <p style={{ color: "#484848" }}>
              We help Businesses and customers achieve more.
            </p>
          </div>
          <div className="d-flex justify-content-center">
            <ul className="row choose-style1__content">
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={remittancesIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Domestic and international remittances</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={walletTransfersIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Bank to Wallet transfers</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={qrPaymentsIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>QR Payments</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={cardlessWithdrawalsIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Cardless withdrawals</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={termDepositsIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Open Term Deposits</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={billPaymentsIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Bill payments</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={schoolPaymentsIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>School payments</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={cardManagementIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Card management services</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-12 col-lg-12 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={biometricIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Biometric authentication</h5>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section id="rewards">
        <img src={rewardsBanner} alt="IZB NXT Rewards Programme" width="100%" />
      </section>

      <section style={{ backgroundColor: "#FFF5E7", padding: "50px 0" }}>
        <div className="container-fluid px-5" style={{ maxWidth: "1300px", margin: "0 auto" }}>
          <h3 style={textColor}>Ways to Earn Points</h3>
          <ol style={{ color: "#484848" }}>
            <li className="mb-2">
              <strong>Transact on IZB NXT Mobile Banking App</strong> — earn points automatically on
              eligible transactions of ZMW100 and above.
            </li>
            <li className="mb-2">
              <strong>Refer a friend</strong> — earn 10 points once the person you refer activates
              their IZB NXT Mobile Banking profile and completes a first transaction of at least
              ZMW100.
            </li>
            <li className="mb-2">
              <strong>Complete self-onboarding</strong> — earn 10 points simply for setting up your
              own IZB NXT Mobile Banking profile.
            </li>
          </ol>
        </div>
      </section>

      <section style={{ backgroundColor: "#ffffff", padding: "50px 0" }}>
        <div className="container-fluid px-5" style={{ maxWidth: "1300px", margin: "0 auto" }}>
          <h3 style={textColor}>Points You Can Earn On Each Transaction</h3>
          <p>
            Points are earned on eligible transactions of ZMW100 or more. Here's what you can earn:
          </p>
          <div className="table-responsive">
            <table className="w-100" style={{ borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th
                    style={{
                      padding: "12px 20px",
                      textAlign: "left",
                      color: "#484848",
                      borderBottom: "2px solid #9E1B1E",
                    }}
                  >
                    Transaction Type
                  </th>
                  <th
                    style={{
                      padding: "12px 20px",
                      textAlign: "left",
                      color: "#484848",
                      borderBottom: "2px solid #9E1B1E",
                    }}
                  >
                    Points Earned
                  </th>
                </tr>
              </thead>
              <tbody>
                {[
                  ["Airtime Recharge", 5],
                  ["Data Bundle Recharge", 5],
                  ["TV Voucher Recharge", 10],
                  ["Utility Payment", 5],
                  ["School Fee Payment", 10],
                  ["DDACC Fund Transfer", 5],
                  ["NFS Bank-to-Bank Transfer", 2],
                  ["NFS Bank-to-Mobile Money Transfer", 2],
                  ["Mobile Money Transfer", 2],
                  ["QR Payments (IZB Scan to Pay)", 10],
                  ["RTGS Funds Transfer", 5],
                  ["Loan Account Transfer", 10],
                  ["Term Deposit Opening", 10],
                  ["Cardless Cash Withdrawal", 10],
                  ["International Fund Transfer", 10],
                ].map(([type, points]) => (
                  <tr key={type} style={{ backgroundColor: "#9E1B1E" }}>
                    <td
                      style={{
                        padding: "12px 20px",
                        color: "#fff",
                        borderBottom: "1px solid rgba(255,255,255,0.15)",
                      }}
                    >
                      {type}
                    </td>
                    <td
                      style={{
                        padding: "12px 20px",
                        color: "#fff",
                        borderBottom: "1px solid rgba(255,255,255,0.15)",
                      }}
                    >
                      {points}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="mt-3">
            <strong>Note:</strong> Transfers between your own IZB accounts and certain fee-free
            transactions do not earn points. Full terms and conditions apply.
          </p>
        </div>
      </section>

      <section style={{ backgroundColor: "#FFF5E7", padding: "50px 0" }}>
        <div className="container-fluid px-5" style={{ maxWidth: "1300px", margin: "0 auto" }}>
          <h3 style={textColor}>Turning Your Points Into Value</h3>
          <p>Your points convert directly into real money in your IZB Bank Account or Wallet:</p>
          <ol>
            <li className="mb-2">
              Conversion rate: 100 points = K10.00, 10 Points = K1, 5 Points = K0.5.
            </li>
            <li className="mb-2">Minimum redemption: 250 points (equivalent to ZMW25.00).</li>
            <li className="mb-2">
              Once you reach or are above the threshold of 250 points, you can redeem your points by
              converting them to cash, deposited into your IZB Bank Account or Wallet, which you can
              use for Funds transfers, Bank to Wallet, Bill payments, Merchant payments, Utility
              Payments, Airtime and data purchases and other Transactions.
            </li>
          </ol>

          <h3 className="mt-4" style={textColor}>
            Who Can Take Part
          </h3>
          <ol>
            <li className="mb-2">
              Individual retail customers with a valid Indo Zambia Bank account and an active IZB NXT
              Mobile Banking profile.
            </li>
            <li className="mb-2">The programme runs throughout 2026.</li>
          </ol>
          <p className="fst-italic mt-3">*Terms and conditions apply.</p>
        </div>
      </section>

      <section className="overview-area">
        <div className="container">
          <div className="row">
            <div
              className=" col-md-6 col-xl-6"
            >
              <div className="overview-content-box-one text-center">
                <img
                  src={bannerPhones1}
                  width="360px"
                  alt=""
                />
              </div>
            </div>
            <div className="col-xl-6 col-md-6 ">
              <div className="overview-content-box-two h-100 d-flex flex-column justify-content-center">
                <div className="inner-title">
                  <h2 style={textColor}>Indo NXT Mobile Banking </h2>
                  <div className="d-flex align-items-center gap-3 my-3">
                    <h5 style={textColor}>Anytime, Anywhere.</h5>
                  </div>
                  <p>
                    Indo NXT Mobile Banking  gives you access to your account on your
                    mobile/tab device. Perform your banking tasks from the palm
                    of your hand, from anywhere and at anytime!
                  </p>
                  <h3 className="py-3" style={textColor}>
                    USSD Dial *232#
                  </h3>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <Link to={androidUrl} target="_blank">
                    <img src={Logo} width={150} style={{ textDecoration: "none", border: "none" }} />
                  </Link>
                  <Link to={iosUrl} target="_blank">
                    <img src={Logo1} width={150} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

 <section className="py-5" style={{ backgroundColor: "#f9f9f9" }}>
  <div className="container-fluid px-4">
    <div className="text-center mb-4">
      <h2 style={{ color: "#9E1B1E" }}>
        Explore our IZB NXT Mobile banking tutorial videos
      </h2>
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "20px",
        overflowX: "auto",
        overflowY: "hidden",
        paddingBottom: "10px",
        scrollSnapType: "x mandatory",
        WebkitOverflowScrolling: "touch",
      }}
    >
      {[
        { src: "https://www.youtube.com/embed/DvATVKEuCas", title: "IZB NXT Mobile Banking Tutorial 1" },
        { src: "https://www.youtube.com/embed/fspEuzSE978", title: "IZB NXT Mobile Banking Tutorial 2" },
        { src: "https://www.youtube.com/embed/KxunBsnWMRY", title: "IZB NXT Mobile Banking Tutorial 3" },
        { src: "https://www.youtube.com/embed/90ZJWiz8LJE", title: "IZB NXT Digital Banking Tutorial" },
      ].map((v) => (
        <div
          key={v.src}
          style={{
            flex: "0 0 auto",
            scrollSnapAlign: "center",
          }}
        >
          <iframe
            width="260"
            height="460"
            src={v.src}
            title={v.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              borderRadius: "12px",
              display: "block",
            }}
          />
        </div>
      ))}
    </div>
  </div>
</section>
    </>
  );
};

export default MobileBanking;
